import { jwtDecode } from "jwt-decode";

const TOKEN_KEY = "auth_token";
const REFRESH_TOKEN_KEY = "admin_refresh_token";

/* ===============================
 TOKEN HELPERS
=============================== */
export const saveToken = (token, refreshToken) => {
 localStorage.setItem(TOKEN_KEY, token);
 if (refreshToken) {
 localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
 }
};

export const getToken = () => {
 return localStorage.getItem(TOKEN_KEY);
};

export const getRefreshToken = () => {
 return localStorage.getItem(REFRESH_TOKEN_KEY);
};

export const logout = () => {
 localStorage.removeItem(TOKEN_KEY);
 localStorage.removeItem(REFRESH_TOKEN_KEY);
};

/* ===============================
 TOKEN VALIDATION
=============================== */
const decodeToken = () => {
 const token = getToken();
 if (!token) return null;

 try {
 return jwtDecode(token);
 } catch (e) {
 return null;
 }
};

const isTokenExpired = () => {
 const decoded = decodeToken();
 if (!decoded || !decoded.exp) return true;

 return decoded.exp * 1000 < Date.now();
};

/* ===============================
 PUBLIC AUTH CHECKS
=============================== */
export const isAuthenticated = () => {
 if (!getToken()) return false;

 if (isTokenExpired()) {
 logout();
 return false;
 }

 return true;
};

export const isAdmin = () => {
 const decoded = decodeToken();
 return decoded?.type === "ADMIN";
};

/* ===============================
 ADMIN LOGIN HELPER (NEW)
=============================== */
export const login = (token) => {
 saveToken(token);
};
